import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PointsAchievedPopupComponent } from './points-achieved-popup.component';

@NgModule({
  declarations: [
    PointsAchievedPopupComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PointsAchievedPopupComponent
  ],
  entryComponents: [
    PointsAchievedPopupComponent
  ]
})
export class PointsAchievedPopupModule {
}
